import iconCode from "@core/assets/icons/careerPositions/code.svg?raw";
import iconTest from "@core/assets/icons/careerPositions/test.svg?raw";
import type { CareerPositionIconKey } from "./careerPositions.js";

export const careerPositionIconByKey = {
	code: iconCode,
	test: iconTest,
} satisfies Record<CareerPositionIconKey, string>;
